import { render } from "./MetaMaskImport.vue?vue&type=template&id=39c8a924&scoped=true"
import script from "./MetaMaskImport.vue?vue&type=script&lang=js"
export * from "./MetaMaskImport.vue?vue&type=script&lang=js"

import "./MetaMaskImport.vue?vue&type=style&index=0&id=39c8a924&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c8a924"]])

export default __exports__